import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-areas-measurements-trx-br",
  templateUrl: "./areas-measurements-trx-br.component.html",
  styleUrls: ["./areas-measurements-trx-br.component.scss"]
})
export class AreasMeasurementsTrxBrComponent implements OnInit {
  @Input() transaction: any;
  @Input() validateBomaList: any;
  typeOpt = 1;

  constructor() {}

  ngOnInit(): void {}
}
